import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=5d02c621&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d02c621",
  null
  
)

export default component.exports